export default [
  {
    path: '/auth',
    name: 'auth',
    component: () => import('./index')
  }
]
